import { etiketBicimi } from "./alan-bicimi";

/**
 * Form alanı etiketi — `Alan`, `Secim` ve `MetinAlani` ortak kullanıyor.
 *
 * ================================================================
 * "(zorunlu)" ETİKETİN DIŞINDA — UI/UX Dalga 1 (M-14, F05)
 * ================================================================
 * Kayıt formunda hangi alanın zorunlu olduğu ancak boş gönderimde
 * kırmızı hatalarla öğreniliyordu. İşaret `<label>`ın İÇİNE konsaydı
 * alanın erişilebilir adı "Ad (zorunlu)" olur, her `getByLabelText("Ad")`
 * ve ekran okuyucu duyurusu değişirdi. Zorunluluğu ekran okuyucuya
 * `aria-required` söylüyor; görünür işaret yalnızca gözle okuyana ve
 * `aria-hidden` — iki kez duyurulmasın.
 *
 * Yıldız (*) değil sözcük: yıldızın anlamı ancak formun başında bir
 * açıklamayla bilinir, "(zorunlu)" kendini anlatıyor.
 */
export function AlanEtiketi({
  htmlFor,
  etiket,
  gizli,
  zorunlu,
}: {
  htmlFor: string;
  etiket: string;
  gizli?: boolean;
  zorunlu?: boolean;
}) {
  const label = (
    <label htmlFor={htmlFor} className={etiketBicimi(gizli)}>
      {etiket}
    </label>
  );
  if (!zorunlu || gizli) return label;
  return (
    <div className="flex items-baseline gap-1">
      {label}
      <span aria-hidden="true" className="text-notr-600 text-xs">
        (zorunlu)
      </span>
    </div>
  );
}
